/**
 * 脏数据处理中心
 * obsolete api -> obsolete http request -> obsolete data -> action.type -> swtich case -> filter -> return clean data -> redux -> component
 */
import * as $$USER from '../actions/userAction'
import * as $$BASE from '../actions/baseAction'
import * as $$REPORT from '../actions/reportAction'
import * as $$COMMON from '../actions/commonAction'
import * as REPORT_TYPES from '../constants/types/reportTypes'
import * as USER_TYPES from '../constants/types/userTypes'
import * as COMMON_TYPE from '../constants/types/commonTypes'
import * as ACTIVITY_TYPE from '../constants/types/activityTypes'

export default store => next => action => {

    if (!action.request || !action.result) {
        return next(action);
    }

    switch (action.type) {
        case REPORT_TYPES.GET_TEAM_HISTORY: {
            action.cleanData = {
                list: _.map(action.result.results, (item, index) => item),
                pageInfo: action.result.mobile_page,
                summery: action.result.win_lose
            };
            break;
        }
        // 获取个人日工资
        case REPORT_TYPES.GET_PERSONAL_DAILY_WAGE: {
            const result = action.result;
            action.cleanData = {
                yesterdayBill: result.yesterday_bill,
                count: result.count,
                total: result.total,
                contract: result.contract,
                list: result.data,
                page: result.mobile_page
            };
            break;
        }
        // 获取个人账变记录
        case REPORT_TYPES.GET_PERSONAL_SELFBANK_RECORD: {
            const result = action.result;
            action.cleanData = {
                orders: result.orders,
                ordertypes: result.ordertypes,
                username: result.username,
                icount: result.icount,
                page: result.mobile_page
            };
            break;
        }
        // 获取团队首页数据
        case REPORT_TYPES.GET_TEAM_USER_LIST: {
            const result = action.result;
            action.cleanData = {
                users: result.users,
                usernames: result.usernames,
                isshow: result.isshow,
                accsum: result.accsum,
                bread: result.bread,
                user: result.user,
                selfdata: result.selfdata,
                page: result.mobile_page
            };
            break;
        }
        // 获取推广链接
        case REPORT_TYPES.GET_AGENT_REG_URL: {
            const result = action.result;
            action.cleanData = {
                domainList: result.domainList,
                links: result.links,
                selfPoint: result.selfPoint,
                selectedPoint: result.selectedPoint,
                prizeGroups: result.prizeGroups
            };
            break;
        }
        // 生成推广链接
        case REPORT_TYPES.MAKE_AGENT_REG_URL: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg_detail || result.sMsg)
            if (result.sMsg.indexOf('成功') > -1) {
                store.dispatch($$REPORT.getAgentRegisterUrL())
            }
            break;
        }
        // 获取下级返点
        case REPORT_TYPES.GET_FOLLOWER_REBET: {
            const result = action.result;
            action.cleanData = {
                user: result.user,
                points: result.points,
                maxPoint: result.maxPoint
            };
            // action.origin.callback();
            break;
        }
        // 获取第三方转账记录
        case REPORT_TYPES.GET_TRANSFER_RECORD: {
            const result = action.result;
            action.cleanData = {
                allTransferInfoList: result.allTransferInfoList,
                page: result.mobile_page
            };
            break;
        }
        // 获取体育反水
        case REPORT_TYPES.GET_SPORT_REBET: {
            const result = action.result;
            action.cleanData = {
                list: result.data,
                count: result.count,
                total: result.total,
                page: result.mobile_page,
                yesterday_bill: result.yesterday_bill,
                contract: result.contract
            };
            break;
        }
        // 获取真人反水
        case REPORT_TYPES.GET_LIVE_REBET: {
            const result = action.result;
            action.cleanData = {
                list: result.data,
                count: result.count,
                total: result.total,
                page: result.mobile_page,
                yesterday_bill: result.yesterday_bill,
                contract: result.contract
            };
            break;
        }
        // 设限下级返点
        case REPORT_TYPES.SET_FOLLOWER_REBET: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg_detail, action.origin.callback)
            break;
        }
        // 获取下级充值限额
        case REPORT_TYPES.GET_TRANSFER_LIMIT: {
            action.transferLimit = action.result.iLimitMoney;
            break;
        }
        // 提交下级转账
        case REPORT_TYPES.SUBMIT_TEAM_GROUP_TRANSFER: {
            const result = action.result;
            if (result.msg_type == 2) {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg)
            } else {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg, action.origin.callback);
                break;
            }
            break;
        }
        // 获取真人，下级反水
        case REPORT_TYPES.GET_LIVE_TEAM_SALARY: {
            const result = action.result;
            action.cleanData = {
                data: result.data,
                count: result.count,
                total: result.total,
                page: result.mobile_page
            };
            break;
        }
        // 获取下级日工资
        case REPORT_TYPES.GET_TEAM_SALARY: {
            const result = action.result;
            action.cleanData = {
                data: result.data,
                count: result.count,
                total: result.total,
                page: result.mobile_page
            };
            break;
        }
        // 获取真人下级契约
        case REPORT_TYPES.GET_TEAM_COMPACT_LIVE: {
            const result = action.result;
            action.cleanData = {
                data: result.data,
                page: result.mobile_page,
                children: result.children
            };
            break;
        }
        // 获取真人下级契约详情
        case REPORT_TYPES.GET_TEAM_COMPACT_DETAIL: {
            const result = action.result;
            action.cleanData = {
                data: result.data
            };
            break;
        }
        // 获取玩法介绍
        case REPORT_TYPES.GET_METHOD_Q_A: {
            const result = action.result;
            action.cleanData = result.data
            break;
        }
        // 获取常见问题
        case REPORT_TYPES.GET_Q_A: {
            const result = action.result;
            action.cleanData = result.content
            break;
        }
        // 获取投注记录
        case REPORT_TYPES.GET_LOTTERY_BET_HIS: {
            const result = action.result;
            action.cleanData = {
                aProject: result.aProject,
                lotteryList: result.lotteryList,
                newMethodList: result.newMethodList,
                page: result.mobile_page
            };
            break;
        }
        // 获取彩票报表概要信息【含盈亏】
        case REPORT_TYPES.GET_WINLOSS_SUMMERY: {
            const result = action.result;
            if (result.sMsg || result.msg_detail) {
                action = $$BASE.openAlert(result.sMsg || result.msg_detail || '网络异常');
            }
            action.cleanData = {
                result: result.result,
                bread: result.bread,
                page: result.mobile_page,
                isContractUser: result.isContractUser
            };
            break;
        }
        // 创建下级契约
        case REPORT_TYPES.CREATE_COMPACT: {
            const result = action.result;
            if (result.msg_type == 2) {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg)
            } else {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg, action.origin.callback);
                break;
            }
            break;
        }
        // 修改下级契约
        case REPORT_TYPES.REVISE_COMPACT: {
            const result = action.result;
            if (result.msg_type == 2) {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg)
            } else {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg, action.origin.callback);
                break;
            }
            break;
        }
        // 获取第三方游戏报表
        case REPORT_TYPES.GET_THRID_PARTY_GAME_REPORT_BYNAME:
        case REPORT_TYPES.GET_THRID_PARTY_GAME_REPORT_BYID: {
            const result = action.result;
            action.cleanData = {
                fromgameArr: result.fromgameArr,
                aSelf: result.aSelf || {},
                aProfitLoss: result.aProfitLoss || [],
                pageCount: result.pageCount || {},
                totalCount: result.totalCount || {},
                loginUserid: result.loginUserid,
                isShowWages: result.isShowWages,
                page: result.mobile_page
            };
            break;
        }
        // 获取第三方游戏投注报表
        case REPORT_TYPES.GET_THRID_PARTY_BET_REPORT: {
            const result = action.result;
            action.cleanData = {
                aProject: result.aProject,
                page: result.mobile_page
            };
            break;
        }
        // 获取第三方游戏报表 下级详情列表
        case REPORT_TYPES.GET_LIVE_RECORD: {
            const result = action.result;
            action.cleanData = {
                aProject: result.aProject,
                page: result.mobile_page
            };
            break;
        }
        // 注册用户
        case USER_TYPES.REGISTER: {
            const result = action.result;
            action = $$BASE.openAlert(result.sMsg)
            if (result.sUrl == '/') {
                location.href = '#/login';
            }
            break;
        }

        // 注册开户
        case USER_TYPES.REGISTER_BY_AGENT: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg_detail)
            if (result.msg_type == 3) {
                location.href = '#/my';
            }
            break;
        }

        // 注册开户用户名校验
        case REPORT_TYPES.CHECK_USERNAME_FOR_REGISTER: {
            const result = action.result;
            action.cleanData = {
                check_username_status: result.status
            }
            if (result.status === 0) {
                store.dispatch($$BASE.openAlert('用户名不可使用'))
            }
            break;
        }
        // 获取投注详情
        case REPORT_TYPES.GET_BET_DETAIL: {
            const result = action.result;
            action.cleanData = {
                project: result.project,
                id: result.id,
                is_cancelable: result.is_cancelable,
                lottery: result.lottery,
                method: result.method,
                nocode: result.nocode,
                username: result.username
            }
            break;
        }
        // 获取追号列表
        case REPORT_TYPES.GET_TRACE_HIS: {
            const result = action.result;
            action.cleanData = {
                lotteryList: result.lotteryList,
                methodList: result.methodList,
                list: result.list,
                username: result.username,
                page: result.mobile_page
            }
            break;
        }
        // 获取追号详情
        case REPORT_TYPES.GET_TRACE_HIS_DETAIL: {
            const result = action.result;
            action.cleanData = {
                aTaskdetail: result.aTaskdetail,
                can: result.can,
                task: result.task
            }
            break;
        }
        // 修改个人资料
        case REPORT_TYPES.MODIFY_PROFILE: {
            const result = action.result;
            action = $$BASE.openAlert(result.sMsg || result.msg_detail || result.message)
            if (result.msg_type && result.msg_type == 3) {
                store.dispatch($$USER.getUserProfile())
            }
            break;
        }
        case COMMON_TYPE.DELETE_ALL_MESSAGE: {
            const result = action.result;
            action = $$BASE.openAlert(result.sMsg || result.msg_detail || result.message)
            store.dispatch($$COMMON.getMessages(1))
            break;
        }
        // 获取彩种返点信息
        case REPORT_TYPES.GET_LOTTERY_REBET_INFO: {
            const result = action.result;
            const aMethod = result.UserMethod ? result.UserMethod : result.aMethod
            const aLottery = result.aLottery ? result.aLottery : result.alottery
            const LimitBonus = result.LimitBonus ? result.LimitBonus : null
            action.cleanData = {
                aLottery: aLottery,
                aMethod: aMethod,
                aPL: result.aPL,
                aPg: result.aPg,
                LimitBonus: LimitBonus
            }
            break;
        }
        // 停止追号
        case REPORT_TYPES.STOP_TRACE_BET: {
            action = $$BASE.openAlert(action.result.msg_detail || action.result.sMsg || '网络异常', action.origin.callback);
            break;
        }
        // 获取日工资下级契约
        case REPORT_TYPES.GET_TEAM_COMPACT_DAILY: {
            const result = action.result;
            action.cleanData = {
                data: result.data,
                page: result.mobile_page
            }
            break;
        }
        // 获取体育下级契约
        case REPORT_TYPES.GET_TEAM_COMPACT_SPORT: {
            const result = action.result;
            action.cleanData = {
                data: result.data,
                page: result.mobile_page,
                children: result.children
            };
            break;
        }
        // 获取下级列表
        case REPORT_TYPES.GET_TEAM_GROUP_LIST: {
            const result = action.result;
            action.cleanData = {
                children: result.children
            };
            break;
        }
        // 同时删除多个站内信
        case COMMON_TYPE.DELETE_MULTI_MESSAGE: {
            const result = action.result;
            if (result.msg_type == 1) {
                action = $$BASE.openAlert(result.msg_detail)
            } else {
                action = $$BASE.openAlert(result.sMsg)
                store.dispatch($$COMMON.getMessages(1))
            }
            break;
        }
        // 检测安全密码是否正确
        case USER_TYPES.CHECK_SECURITY_PASS: {
            const result = action.result;
            if (result.msg_type == 2) {
                action = $$BASE.openAlert(result.msg_detail)
            } else {
                if (result.sMsg) {
                    action = $$BASE.openAlert(result.sMsg);
                    break;
                }
                action.origin.callback(result);
            }
            break;
        }
        // 校验密保问题
        case USER_TYPES.CHECK_SECURITY_QUESTION: {
            const result = action.result;
            // 失败
            if (result.msg_type == 2 || result.sMsg) {
                action = $$BASE.openAlert(result.msg_detail || result.sMsg)
            } else {
                // 成功
                action.origin.callback(result);
            }
            break;
        }
        // 修改提款密码
        case USER_TYPES.UPDATE_WITHDRAWAL_PASS: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg)
            break;
        }
        // 活动详情
        case ACTIVITY_TYPE.GET_ACTIVITY_DETAIL: {
            const result = action.result;
            action.cleanData = result.activity
            break;
        }
        // 参与活动
        case ACTIVITY_TYPE.PLAY_ACTIVITY: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg_detail || result.sMsg || '网络异常');
            break;
        }
        // 撤单
        case REPORT_TYPES.CANCEL_GAME_ORDER: {
            const result = action.result;
            action = $$BASE.openAlert(result.msg_detail || result.sMsg || '网络异常', action.origin.callback);
            break;
        }
        // 获取彩票账变
        case REPORT_TYPES.LOTTERY_ACCOUNT_CHANGED: {
            const result = action.result;
            action.cleanData = {
                aOrders: result.aOrders,
                lottery_new: result.lottery_new,
                modes: result.modes,
                type: result.type,
                page: result.mobile_page
            }
            break;
        }
        // 获取彩票契约分红
        case REPORT_TYPES.LOTTERY_DIVIDENDS_PINK: {
            const result = action.result;
            action.cleanData = {
                billStatus: result.billStatus,
                childrenBill: result.childrenBill,
                currentCycle: result.currentCycle,
                cycles: result.cycles,
                iUserid: result.iUserid,
                selfBill: result.selfBill,
                selfPayStatus: result.selfPayStatus,
                selfMax: result.selfMax,
                setLimit: result.setLimit,
                setRules: result.setRules,
                user: result.user,
                page: result.mobile_page
            }
            if (action.origin.callback) {
                action.origin.callback(result);
            }
            break;
        }
        // 彩票契约查询分红发放状态
        case REPORT_TYPES.GET_LOTTERY_PINK_STATUS:
        // 发放分红
        case REPORT_TYPES.SEND_LOTTERY_PINK:
        // 更新分红
        case REPORT_TYPES.UPDATE_PINK_CONTRACT:
        // 查看分红契约
        case REPORT_TYPES.VIEW_LOTTERY_PINK:
        // 创建分红契约
        case REPORT_TYPES.CREATE_PINK_CONTRACT:
        // 更新分红契约
        case REPORT_TYPES.MODIFY_PINK_CONTRACT: {
            const result = action.result;
            action.cleanData = {
                result: result
            }
            if (action.origin.callback) {
                action.origin.callback(result);
            }
            break;
        }
    }

    return next(action);

}
